function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 13"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 6.6a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.44 5.8c.35-.28.56-.53.56-.99 0-.52-.37-.9-.98-.9-.67 0-1.15.4-1.14 1.34H3.75C3.72 3.92 4.57 3 6.02 3c1.5 0 2.13.83 2.13 1.76 0 .81-.38 1.24-.92 1.68l-.5.4c-.24.2-.32.27-.32.57v.38H5.4v-.54c0-.55.12-.68.58-1.06l.47-.39zm.13 2.8v1.2H5.22V8.6h1.35z",
  clipRule: "evenodd"
})));